/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleX = createReactComponent("circle-x", "IconCircleX", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 10l4 4m0 -4l-4 4", key: "svg-1" }]
]);

export { IconCircleX as default };
//# sourceMappingURL=IconCircleX.js.map
